export default "__VITE_ASSET__D58kD5Gs__"